"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initUploadModule = initUploadModule;
const apiService_1 = require("./apiService");
const cryptoService_1 = require("./cryptoService");
const queue_1 = require("./queue");
const fileUploader_1 = require("./fileUploader");
const telemetry_1 = require("./telemetry");
const manager_1 = require("./manager");
const blockVerifier_1 = require("./blockVerifier");
/**
 * Provides facade for the upload module.
 *
 * The upload module is responsible for handling file uploads, including
 * metadata generation, content upload, API communication, encryption,
 * and verifications.
 */
function initUploadModule(telemetry, apiService, driveCrypto, sharesService, nodesService, nodesEvents) {
    const api = new apiService_1.UploadAPIService(apiService);
    const cryptoService = new cryptoService_1.UploadCryptoService(driveCrypto, nodesService);
    const uploadTelemetry = new telemetry_1.UploadTelemetry(telemetry, sharesService);
    const manager = new manager_1.UploadManager(telemetry, api, cryptoService, nodesService, nodesEvents);
    const queue = new queue_1.UploadQueue();
    async function getFileUploader(parentFolderUid, name, metadata, signal) {
        await queue.waitForCapacity(signal);
        let revisionDraft, blockVerifier;
        try {
            revisionDraft = await manager.createDraftNode(parentFolderUid, name, metadata);
            blockVerifier = new blockVerifier_1.BlockVerifier(api, cryptoService, revisionDraft.nodeKeys.key, revisionDraft.nodeRevisionUid);
            await blockVerifier.loadVerificationData();
        }
        catch (error) {
            queue.releaseCapacity();
            if (revisionDraft) {
                await manager.deleteDraftNode(revisionDraft.nodeUid);
            }
            void uploadTelemetry.uploadInitFailed(parentFolderUid, error, metadata.expectedSize);
            throw error;
        }
        const onFinish = async (failure) => {
            queue.releaseCapacity();
            if (failure) {
                await manager.deleteDraftNode(revisionDraft.nodeUid);
            }
        };
        return new fileUploader_1.Fileuploader(uploadTelemetry, api, cryptoService, manager, blockVerifier, revisionDraft, metadata, onFinish, signal);
    }
    async function getFileRevisionUploader(nodeUid, metadata, signal) {
        await queue.waitForCapacity(signal);
        let revisionDraft, blockVerifier;
        try {
            revisionDraft = await manager.createDraftRevision(nodeUid, metadata);
            blockVerifier = new blockVerifier_1.BlockVerifier(api, cryptoService, revisionDraft.nodeKeys.key, revisionDraft.nodeRevisionUid);
            await blockVerifier.loadVerificationData();
        }
        catch (error) {
            queue.releaseCapacity();
            if (revisionDraft) {
                await manager.deleteDraftRevision(revisionDraft.nodeRevisionUid);
            }
            void uploadTelemetry.uploadInitFailed(nodeUid, error, metadata.expectedSize);
            throw error;
        }
        const onFinish = async (failure) => {
            queue.releaseCapacity();
            if (failure) {
                await manager.deleteDraftNode(revisionDraft.nodeUid);
            }
        };
        return new fileUploader_1.Fileuploader(uploadTelemetry, api, cryptoService, manager, blockVerifier, revisionDraft, metadata, onFinish, signal);
    }
    return {
        getFileUploader,
        getFileRevisionUploader,
    };
}
//# sourceMappingURL=index.js.map